import {Component, OnDestroy, OnInit} from '@angular/core';
import {GridApi, IAfterGuiAttachedParams} from 'ag-grid-community';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {FormService} from '../../../services/form.service';
import {Dienst, ShipmentInfo} from '../../../models';

@Component({
  selector: 'lib-radioaktiv-cell',
  templateUrl: 'radioaktiv-cell.component.html',
  styleUrls: ['./radioaktiv-cell.component.css']
})
export class RadioaktivCellComponent implements ICellRendererAngularComp, OnDestroy, OnInit {

  public params: any;
  public gridApi: GridApi;

  public isRadioActive: boolean = false;

  constructor(private formService: FormService) {
  }

  ngOnInit(): void {
    this.formService.shipmentInfo.subscribe((shipmentInfoDetail: ShipmentInfo[]) => {
      shipmentInfoDetail.forEach((info: ShipmentInfo) => {
        info.dienste.forEach((dienst: Dienst) => {
          if (dienst.dienstart === 'I' && dienst.code === 'GGVS3' || dienst.code === 'GGVS8') {
            this.isRadioActive = true;
          }
        });
      });
    });
  }

  agInit(params: any): void {
    this.params = params;
    this.gridApi = params.api;
  }

  ngOnDestroy(): void {
  }

  refresh(): boolean {
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

}
